import { useEffect, useState } from "react"
import { getLocations } from "../services/location";
import { getLocationOpenHours } from "../services/locationOpenHour";
import useWebData from "../hooks/useWebData";
import moment from "moment";
import { tenantId } from "../config/api";
import { Helmet } from "react-helmet-async";


export const OpeningHours = () => {
    const { webData }: any = useWebData();
    const [allLocations, setAllLocations] = useState<any[]>([]);
    const [allLocationsOpeningHours, setAllLocationsOpeningHours] = useState<any[]>([]);
    const [dataIsLoaded, setDataIsLoaded] = useState<boolean>(false);

    useEffect(() => {
        setDataIsLoaded(false);
        getLocations(tenantId)
            .then((data) => {
                if (data?.length <= 0) {
                    setDataIsLoaded(true);
                }
                setAllLocations(data);
            })
            .catch((error) => {
                console.error(error);
                setDataIsLoaded(true);
                setAllLocations([]);
            })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (allLocations.length > 0) {
            setDataIsLoaded(false);
            getLocationOpenHours(tenantId)
                .then((data) => {
                    const result = data
                        ?.filter((item: any) => (new Date(item?.startDate) <= new Date() && new Date(item?.endDate) >= new Date()))
                        ?.map((item: any) => {
                            return {
                                sundayOpenTime: item?.isSundayOpen ? item?.sundayOpenTime ? moment(item?.sundayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                sundayCloseTime: item?.isSundayOpen ? item?.sundayCloseTime ? moment(item?.sundayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                mondayOpenTime: item?.isMondayOpen ? item?.mondayOpenTime ? moment(item?.mondayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                mondayCloseTime: item?.isMondayOpen ? item?.mondayCloseTime ? moment(item?.mondayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                tuesdayOpenTime: item?.isTuesdayOpen ? item?.tuesdayOpenTime ? moment(item?.tuesdayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                tuesdayCloseTime: item?.isTuesdayOpen ? item?.tuesdayCloseTime ? moment(item?.tuesdayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                wednesdayOpenTime: item?.isWednesdayOpen ? item?.wednesdayOpenTime ? moment(item?.wednesdayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                wednesdayCloseTime: item?.isWednesdayOpen ? item?.wednesdayCloseTime ? moment(item?.wednesdayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                thursdayOpenTime: item?.isThursdayOpen ? item?.thursdayOpenTime ? moment(item?.thursdayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                thursdayCloseTime: item?.isThursdayOpen ? item?.thursdayCloseTime ? moment(item?.thursdayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                fridayOpenTime: item?.isFridayOpen ? item?.fridayOpenTime ? moment(item?.fridayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                fridayCloseTime: item?.isFridayOpen ? item?.fridayCloseTime ? moment(item?.fridayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                saturdayOpenTime: item?.isSaturdayOpen ? item?.saturdayOpenTime ? moment(item?.saturdayOpenTime, 'HH:mm').format('hh:mm A') : "" : "",
                                saturdayCloseTime: item?.isSaturdayOpen ? item?.saturdayCloseTime ? moment(item?.saturdayCloseTime, 'HH:mm').format('hh:mm A') : "" : "",
                                locationId: item?.locationId
                            }
                        });
                    setAllLocationsOpeningHours(result);
                    setDataIsLoaded(true);
                })
                .catch((error) => {
                    setDataIsLoaded(true);
                    console.error(error);
                    setAllLocationsOpeningHours([]);
                })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allLocations])


    return (
        <>
            <Helmet>
                <title>Vehicle & Van Rental Locations | Opening Hours</title>
                <meta
                    name="description"
                    content="Check opening hours for our vehicle and van rental locations. Find daily business hours, location details, and plan your rental visit easily."
                />
            </Helmet>
            <div className="mt-[140px] p-6">
                <div className="text-center">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-800">
                        Opening Hours for Our Vehicle Rental Locations
                    </h1>
                </div>

                {
                    dataIsLoaded
                        ? (
                            allLocationsOpeningHours?.length > 0
                                ? (
                                    <div className="max-w-6xl mx-auto p-4 grid gap-6 lg:grid-cols-3 content-center mt-12">
                                        {
                                            allLocations?.map((item: any, index: number) => {
                                                const openHour = allLocationsOpeningHours?.find((openHour: any) => openHour?.locationId === item?.id);

                                                return (
                                                    <div
                                                        key={index}
                                                        className="p-6 bg-white rounded-2xl shadow-md border border-gray-200"
                                                    >
                                                        <h2 className="text-xl font-semibold mb-1"
                                                            style={{
                                                                color: webData?.websiteHeaderColor,
                                                            }}
                                                        >
                                                            {item?.locationName}
                                                        </h2>
                                                        <p className="text-gray-600 mb-4">{item?.street}, {item?.city}, {item?.state} {item?.zipCode}, {item?.country}</p>

                                                        <div className="grid grid-cols-1 gap-y-2">
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Sunday</span>
                                                                {
                                                                    !openHour?.sundayOpenTime && !openHour?.sundayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.sundayOpenTime} - {openHour?.sundayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Monday</span>
                                                                {
                                                                    !openHour?.mondayOpenTime && !openHour?.mondayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.mondayOpenTime} - {openHour?.mondayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Tuesday</span>
                                                                {
                                                                    !openHour?.tuesdayOpenTime && !openHour?.tuesdayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.tuesdayOpenTime} - {openHour?.tuesdayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Wednesday</span>
                                                                {
                                                                    !openHour?.wednesdayOpenTime && !openHour?.wednesdayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.wednesdayOpenTime} - {openHour?.wednesdayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Thursday</span>
                                                                {
                                                                    !openHour?.thursdayOpenTime && !openHour?.thursdayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600 text-center">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.thursdayOpenTime} - {openHour?.thursdayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Friday</span>
                                                                {
                                                                    !openHour?.fridayOpenTime && !openHour?.fridayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.fridayOpenTime} - {openHour?.fridayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                            <div className="flex justify-between text-sm">
                                                                <span className="font-medium text-gray-700">Saturday</span>
                                                                {
                                                                    !openHour?.saturdayOpenTime && !openHour?.saturdayCloseTime
                                                                        ? (
                                                                            <span className="text-red-600">Closed</span>
                                                                        ) : (
                                                                            <span className="text-gray-600">{openHour?.saturdayOpenTime} - {openHour?.saturdayCloseTime}</span>
                                                                        )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                ) : (
                                    <div className="h-[calc(100vh-220px)] px-[1rem] py-[0.5rem] my-[1.5rem]">
                                        <div className="bg-white w-full h-full rounded-lg"                              >
                                            <div className="h-full flex items-center justify-center gap-x-[2rem] px-[2rem] py-[1rem] min-h-[24rem]">
                                                <p className="text-sm text-gray-400">No opening hours available.</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                        ) : (
                            <div className="h-[calc(100vh-220px)] px-[1rem] py-[0.5rem] my-[1.5rem]">
                                <div className="bg-white w-full h-full rounded-lg"                              >
                                    <div className="h-full flex items-center justify-center gap-x-[2rem] px-[2rem] py-[1rem] min-h-[24rem]">
                                        <p className="text-sm text-gray-400">Loading...</p>
                                    </div>
                                </div>
                            </div>
                        )
                }
            </div>
        </>

    )
}